import React from 'react';
import ChatInterface from './ChatInterface';
import { MODULE_TYPES } from '../../constants/chatModuleConfig';
import '../../styles/main.scss';

/**
 * BRD module page — reuses ChatInterface with BRD-specific copy from chatModuleConfig.
 * Upload, query, and rendering are identical to Tech Doc; only UI text differs.
 */
const BRDGeneration = () => {
  return (
    <div className="ibeam-container" style={{ padding: '16px', position: 'relative' }}>
      <ChatInterface moduleType={MODULE_TYPES.BRD} />
    </div>
  );
};

export default BRDGeneration;
